var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-title',{staticClass:"text-sm-h4 text-h5 justify-center breakword",domProps:{"innerHTML":_vm._s(_vm.text)}})
}
var staticRenderFns = []

export { render, staticRenderFns }